<template>
  <FontAwesomeIcon :icon="iconClass" :size="size" />
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default defineComponent({
  name: 'AppIcon',
  components: { FontAwesomeIcon },
  props: {
    icon: {
      type: [String, Array],
      required: true
    },
    size: {
      type: String,
      default: null,
      validator: (value: string) => {
        return [
          '2xs',
          'xs',
          'sm',
          'lg',
          'xl',
          '2xl',
          '1x',
          '2x',
          '3x',
          '4x',
          '5x',
          '6x',
          '7x',
          '8x',
          '9x',
          '10x'
        ].includes(value)
      }
    }
  },
  data() {
    return {
      defaultIconFamily: 'fas',
      definedIcons: ref<Map<string, string[]>>(
        new Map([
          ['change', ['fas', 'arrow-turn-left']],
          ['store', ['fas', 'clock']],
          ['next', ['fas', 'angle-right']],
          ['previous', ['fas', 'angle-left']],
          ['maintenance', ['fas', 'person-digging']],
          ['schedule', ['fas', 'circle-plus']],
          ['warning', ['fas', 'triangle-exclamation']],
          ['serviceAppointment', ['fas', 'wrench']],
          ['roadsideAssistance', ['fas', 'face-frown']],
          ['adviserSelectionAppointment', ['fas', 'users']],
          ['freeAppointment', ['fas', 'calendar-days']],
          ['check', ['fas', 'check-circle']],
          ['close', ['fas', 'times-circle']],
          ['biography', ['fas', 'circle-user']],
          ['reviews', ['fas', 'circle-star']],
          ['locked', ['fas', 'lock']],
          ['info', ['fal', 'circle-info']],
          ['plus', ['fas', 'plus']],
          ['testDrive', ['fas', 'steering-wheel']],
          ['adviserAppointment', ['fas', 'user-clock']],
          ['eye', ['fass', 'fa-eye']],
          ['video', ['fas', 'video']],
          ['pathCta', ['fad', 'circle-arrow-down']],
          ['appointmentConfirm', ['fas', 'circle-check']],
          ['adviserReviews', ['fass', 'circle-user-circle-question']],
          ['star', ['fas', 'star']],
          ['quote', ['fasds', 'quote-right']]
        ])
      )
    }
  },

  computed: {
    iconClass(): string[] | string {
      if (Array.isArray(this.icon)) {
        return this.icon as string[]
      } else if (this.definedIcons.get(this.icon)) {
        return this.definedIcons.get(this.icon) as string[]
      }
      return [this.defaultIconFamily, this.icon]
    }
  }
})
</script>
